import { paginationFragment } from './fragments/pagination';

const fragment = `
  id
  name
  filename
  contentType
  byteSize
  fileUrl
  updatedAt
`;

export const listDocumentsQuery = `
  query ListDocuments(
    $filter: DocumentFilterInput
    $page: Int
    $pageSize: Int
  ) {
    result: listDocuments(filter: $filter, page: $page, pageSize: $pageSize) {
      items {
        ${fragment}
      }
      pagination {
        ${paginationFragment}
      }
    }
  }
`;

export const createDocumentQuery = `
  mutation CreateDocument(
    $input: CreateDocumentInput!
    $file: Upload
  ) {
    item: createDocument(input: $input, file: $file) {
      ${fragment}
    }
  }
`;

export const updateDocumentQuery = `
  mutation UpdateDocument(
    $input: UpdateDocumentInput!
    $file: Upload
  ) {
    item: updateDocument(input: $input, file: $file) {
      ${fragment}
    }
  }
`;

export const deleteDocumentQuery = `
  mutation DeleteDocument(
    $id: Int!
  ) {
    item: deleteDocument(id: $id) {
      ${fragment}
    }
  }
`;
